module.exports = __webpack_public_path__ + "static/corona-banner.e8a5f04d.jpg";